export default {
    BAIXA: 1,
    ESTORNO: 2,
    INDISPONIBILIDADE: 3,
}